// eslint-disable-next-line no-unused-vars
// import { get, post } from 'request';

// eslint-disable-next-line import/prefer-default-export
export function uploadImg(argument) {
    return this.$post({
        // type: 'file',
        options: {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        },
        url: '/api/upload/picture.ajax',
        body: argument,
    });
}
